// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixUsers from "wix-users"
import wixData from "wix-data"

$w.onReady(function () {
	$w('#text106').collapse()
	$w('#text105').collapse()
});

async function fail() {
	$w('#text106').expand()
	$w('#text105').collapse()
}
async function success() {
	$w('#text106').collapse()
	$w('#text105').expand()
}

export function radioGroup1_click(event) {
	let value = $w('#radioGroup1').value
	$w('#reciept').fileType = value
}





export function submit_click(event) {

	let tos = $w('#checkbox1').checked
	if (!tos) {
		fail()
		return
	}

	// get values
	let firstName = $w('#name').value
	let lastName = $w('#family').value
	let email = $w('#mail').value
	let phone = $w('#phone').value
	let serial = $w('#serialnumber').value
	let product = $w('#product').value

	// upload the file
	$w('#reciept').startUpload()
	.then(uploadedFile => {
		let receipt = uploadedFile.url

		


		// make sure all fields are full
		if (firstName == "" || lastName == "" || email == "" || phone == "" || serial == "" || product == "" || receipt == "") {
			console.log("Missing info")
			fail()
			return
		}

		// get the product from db
		wixData.query("icare-products")
		.eq("title", product)
		.find()
		.then(result => {
			let product_ref = result["items"][0]

			// insert details into private-icare db
			let values = {
				"title": firstName,
				"name": firstName,
				"family": lastName,
				"email": email,
				"phone": phone,
				"receipt": uploadedFile,
				"serial": serial,
				"product": product_ref,
				"policy": tos
			}
			wixData.insert("private-icare", values)
			.then(result1 => {

				// send a mail 
				// convert the recipt into a readable url
				let documentUrl, matches, convertRegex;
				
				if (receipt.includes("document")) {
					convertRegex = new RegExp(/wix:document:\/\/v1\/([^\/]+)\/(.*)$/);
					matches = receipt.match(convertRegex);
					documentUrl = `https://docs.wixstatic.com/ugd/${matches[1]}?dn=${matches[2]}`;
				}
				else if (receipt.includes("image")) {
					convertRegex = new RegExp(/wix:image:\/\/v1\/([^\/]+)\/(.*)$/);
					matches = receipt.match(convertRegex);
					documentUrl = `https://images.wixstatic.com/media/${matches[1]}?dn=${matches[2]}`;
				} else {
					console.log("unkown format")
					fail()
					return
				}
				console.log(documentUrl)


				//, 
				wixUsers.emailUser('privateIcare', "9513de23-896d-4460-a612-3bc8a350b59c", {
					variables: {
						serial: serial,
						name: firstName,
						URL: documentUrl,
						family: lastName,
						product: product
					}
				})
				.then(result2 => {
					console.log("success!")
					success()
				})
				.catch(err_mail => {
					console.log(err_mail)
					fail()
				})
			})
			.catch(err_db => {
				console.log(err_db)
				fail()
			})
		})
	})
	.catch(err_upload => {
		console.log(err_upload)
		fail()
	})
}


export function product_change(event) {
	console.log("calculating price for " + $w('#product').value)
	wixData.query("icare-products")
	.eq("title", $w('#product').value)
	.find()
	.then(result => {
		console.log(result)
		if (result.items.length == 0) return
		console.log("found product")
		let product = result.items[0]
		let price = product["privatePrice"]
		if (price == undefined) price = "Unknown"
		$w('#text109').text = price.toString()
	})
}